module.exports = __webpack_public_path__ + "assets/img/paysuccess_tippic_img.b4f1a845.png";